import {
  PaymentStatusSchema,
  type PaymentStatus as GeneratedPaymentStatus
} from '~/services/api/generated'

// Mirrors backend App\Enums\Payment\PaymentStatus

export type PaymentStatus = GeneratedPaymentStatus

export const PaymentStatus = {
  REQUESTED: PaymentStatusSchema.enum.requested,
  PENDING: PaymentStatusSchema.enum.pending,
  COMPLETED: PaymentStatusSchema.enum.completed,
  FAILED: PaymentStatusSchema.enum.failed,
  CANCELLED: PaymentStatusSchema.enum.cancelled,
  REFUNDED: PaymentStatusSchema.enum.refunded,
  REFUND_REVERSED: PaymentStatusSchema.enum.refund_reversed,
  NOT_REQUIRED: PaymentStatusSchema.enum.not_required,
  PARTIALLY_PAID: PaymentStatusSchema.enum.partially_paid
} satisfies Record<string, GeneratedPaymentStatus>

export const PaymentStatusValues: readonly GeneratedPaymentStatus[] = [
  PaymentStatusSchema.enum.requested,
  PaymentStatusSchema.enum.pending,
  PaymentStatusSchema.enum.completed,
  PaymentStatusSchema.enum.failed,
  PaymentStatusSchema.enum.cancelled,
  PaymentStatusSchema.enum.refunded,
  PaymentStatusSchema.enum.refund_reversed,
  PaymentStatusSchema.enum.not_required,
  PaymentStatusSchema.enum.partially_paid
]
